import { ContactsPage } from '@features/contacts/components/ContactsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/contacts')({ component: ContactsPage });
